"use strict";
var page = document.documentElement;
var switchers = document.querySelectorAll(".page__theme-switcher");
var links = document.querySelectorAll(".link");
var buttons = document.querySelectorAll(".button");
var inputs = document.querySelectorAll(".input");
var services = document.querySelectorAll(".service");
var contactUs = document.querySelector(".contact-us");
var avas = document.querySelectorAll(".ava");
var customers = document.querySelectorAll(".customer");
function setThemeBasedOnUserPreference() {
    if (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) {
        if (page.classList.contains(".page--theme--light")) {
            page.classList.remove("page--theme--light");
            contactUs.classList.remove("contact-us--theme--light");
            links.forEach(function(link) {
                link.classList.remove("link--theme--light");
            });
            buttons.forEach(function(button) {
                button.classList.remove("button--theme--light");
            });
            inputs.forEach(function(input) {
                input.classList.remove("input--theme--light");
            });
            services.forEach(function(service) {
                service.classList.remove("service--theme--light");
            });
            avas.forEach(function(ava) {
                ava.classList.remove("ava--theme--light");
            });
            customers.forEach(function(customer) {
                customer.classList.remove("customer--theme--light");
            });
        }
    } else {
        page.classList.add("page--theme--light");
        contactUs.classList.add("contact-us--theme--light");
        links.forEach(function(link) {
            link.classList.add("link--theme--light");
        });
        buttons.forEach(function(button) {
            button.classList.add("button--theme--light");
        });
        inputs.forEach(function(input) {
            input.classList.add("input--theme--light");
        });
        services.forEach(function(service) {
            service.classList.add("service--theme--light");
        });
        avas.forEach(function(ava) {
            ava.classList.add("ava--theme--light");
        });
        customers.forEach(function(customer) {
            customer.classList.add("customer--theme--light");
        });
    }
}
setThemeBasedOnUserPreference();
switchers.forEach(function(switcher) {
    switcher.addEventListener("click", function() {
        if (page.classList.contains("page--theme--light")) {
            page.classList.remove("page--theme--light");
            contactUs.classList.remove("contact-us--theme--light");
            links.forEach(function(link) {
                link.classList.remove("link--theme--light");
            });
            buttons.forEach(function(button) {
                button.classList.remove("button--theme--light");
            });
            inputs.forEach(function(input) {
                input.classList.remove("input--theme--light");
            });
            services.forEach(function(service) {
                service.classList.remove("service--theme--light");
            });
            avas.forEach(function(ava) {
                ava.classList.remove("ava--theme--light");
            });
            customers.forEach(function(customer) {
                customer.classList.remove("customer--theme--light");
            });
        } else {
            page.classList.add("page--theme--light");
            contactUs.classList.add("contact-us--theme--light");
            links.forEach(function(link) {
                link.classList.add("link--theme--light");
            });
            buttons.forEach(function(button) {
                button.classList.add("button--theme--light");
            });
            inputs.forEach(function(input) {
                input.classList.add("input--theme--light");
            });
            services.forEach(function(service) {
                service.classList.add("service--theme--light");
            });
            avas.forEach(function(ava) {
                ava.classList.add("ava--theme--light");
            });
            customers.forEach(function(customer) {
                customer.classList.add("customer--theme--light");
            });
        }
    });
});

//# sourceMappingURL=index.47c9302f.js.map
